import "./skills.scss";
import * as React from 'react';
import {
    Accordion, AccordionDetails,
    AccordionSummary,
    Box,
    LinearProgress,
    linearProgressClasses,
    styled,
} from "@mui/material";
import {skills_data} from "../../data/data";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Career from "../career/career";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    width: "70%",
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: 'rgba(76, 2, 241, 0.3)',
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: 'rgba(145, 42, 237, 0.8)',
    },
}));

export default function Skills(){
    const percentage = 30;
    const [expanded, setExpanded] = React.useState('panel0');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div className="skills" id={"skills"}>
            <div className={"content"}>
                <h2 className={"title"}>Compétence & carrière</h2>
                <span className={"divider"}/>
                {skills_data.map((category, index)=>
                    <Accordion className={"accordion-skills"} TransitionProps={{ unmountOnExit: true }} expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}`}
                    ><h3 className={"title"}><FontAwesomeIcon icon={category.icons} className={"icons"} />{category.nameCategory}</h3>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className={"wrapper-skills"}>
                            {category.skills.map((element)=>
                                <Box className={"skill-element"}>
                                    <div className={"skill-title"}>
                                        <div>
                                            <h3>{element.name}</h3>
                                        </div>
                                        <div>{element.level}%</div>
                                    </div>
                                    <BorderLinearProgress variant="determinate" value={element.level}/>
                                </Box>
                            )}

                        </div>
                    </AccordionDetails>
                </Accordion>)}
            </div>
            <Career />
        </div>
    )
}